$(document).ready(function(){

  // var REDIRECT_PATH = '/';
  // var selector = '#customer_login',
  //     $form = document.querySelectorAll(selector)[0];

  // if ($form) {
  //   $redirect = document.createElement('input');
  //   $redirect.setAttribute('name', 'return_to');
  //   $redirect.setAttribute('type', 'hidden');
  //   $redirect.value = REDIRECT_PATH;
  //   $form.appendChild($redirect);
  // }
  $(document).on('click','#menuToggle', ()=>{
    $('.js-header-mobile-accordion-container').addClass('--active');
  });
  
$(document).on('click','.login-popup__close', function(){
    $('.js-login-popup-container').removeClass('login-popup__container--opened');
    $('body').removeClass('login-popup-active');
});
  


$(document).on('mouseover','.header-menu .header-menu__item', function(){
    $(this).parents('.header-menu').next().addClass('active');
});

$(document).on('mouseout','.header-menu .header-menu__item', function(){
    $(this).parents('.header-menu').next().removeClass('active');
});
function domeChange() {
    let elem = document.querySelector('.main_custom_class_col'); // target div in which you want to detect changes
    let observer = new MutationObserver(mutationRecords => {
      StampedFn.loadBadges();
       console.log(mutationRecords[0].addedNodes); // console.log(the changes)
    });

    // observe everything except attributes
    observer.observe(elem, {
      childList: true, // observe direct children
      subtree: true, // and lower descendants too
      characterData: true,
      oldValue: true,
      characterDataOldValue: true // pass old data to callback
    });
}
domeChange();

$(function () {
  $(".ddl-select").each(function () {
    $(this).hide();
    var $select = $(this);
    var _id = $(this).attr("id");
    var wrapper = document.createElement("div");
    wrapper.setAttribute("class", "ddl ddl_" + _id);

    var input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("class", "ddl-input");
    input.setAttribute("id", "ddl_" + _id);
    input.setAttribute("readonly", "readonly");
    input.setAttribute(
      "placeholder",
      $(this)[0].options[$(this)[0].selectedIndex].innerText
    );
    

    $(this).before(wrapper);
    var $ddl = $(".ddl_" + _id);
    $ddl.append(input);
    $ddl.append("<div class='ddl-options ddl-options-" + _id + "'></div>");
    var $ddl_input = $("#ddl_" + _id);
    var $ops_list = $(".ddl-options-" + _id);
    var $ops = $(this)[0].options;
    for (var i = 0; i < $ops.length; i++) {
      $ops_list.append(
        "<div data-value='" +
          $ops[i].value +
          "'>" +
          $ops[i].innerText +
          "</div>"
      );
    }



    
    $ddl_input.click(function () {
      $(".ddl-options.ddl-options-sort-by").toggle();
      $ddl.toggleClass("active");
      
    });
    $ddl_input.blur(function () {
      $ddl.removeClass("active");
    });
    $ops_list.find("div").click(function () {
      $select.val($(this).data("value")).trigger("change");
      $ddl_input.val($(this).text());
      $ddl.removeClass("active");
      $(".ddl-options.ddl-options-sort-by").hide();
      $("#sort-by").val($(this).attr("data-value")).trigger('change');
    });
  });
  $(".ddl-options.ddl-options-sort-by").hide();
var get_currenty = window.location.href;
if(get_currenty.includes('sort_by=')){
var get_last = get_currenty.split('sort_by=').pop();
  $(".ddl-options.ddl-options-sort-by div[data-value="+get_last+"]").trigger('click');
}
});



var get_console = window.location.href;
// if(get_console.includes('price-ascending')){

// var jsonobj = [];
// $(".collection-products__col.collection-products__col--four .js-variant-price").each(function(){
// var currtxt = $(this).text().trim();
// var amt = currtxt.replace(/[A-Za-z$-.]/g, "").trim();    
// jsonobj.push(parseInt(amt)/100);    
// });

// function onlyUnique(value, index, self) {
//   return self.indexOf(value) === index;
// }
// var unique = jsonobj.filter(onlyUnique);
// var finalarray = unique.sort((a, b) => a - b);
// var check_index = 0 ; 
// var k = 0;
// for (var i = 0; i < finalarray.length; i++) {
// var numbrs = finalarray[i];
// $(".collection-products__col.collection-products__col--four .js-variant-price").each(function(index){
// var currtxt = $(this).text().trim();

// var amt = parseInt(currtxt.replace(/[A-Za-z$-.]/g, "").trim())/100; 
//  if(numbrs == amt) {
//      $(this).parents(".collection-products__col.collection-products__col--four").css("order",i);
//      $(this).parents(".collection-products__col.collection-products__col--four").attr("data-order",i);

//  }  
// });
    
// }
// $("ul.list--inline.pagination").css("order",finalarray.length);
// }else if(get_console.includes('price-descending')){
// var jsonobj = [];
// $(".collection-products__col.collection-products__col--four .js-variant-price").each(function(){
// var currtxt = $(this).text().trim();
// var amt = currtxt.replace(/[A-Za-z$-.]/g, "").trim();    
// jsonobj.push(parseInt(amt)/100);    
// });

// function onlyUnique(value, index, self) {
//   return self.indexOf(value) === index;
// }
// var unique = jsonobj.filter(onlyUnique);
// var inarrays = unique.sort((a, b) => a - b);
// var finalarray = inarrays.reverse();
// for (var i = 0; i < finalarray.length; i++) {
// var numbrs = finalarray[i];
// $(".collection-products__col.collection-products__col--four .js-variant-price").each(function(){
// var currtxt = $(this).text().trim();
// var amt = parseInt(currtxt.replace(/[A-Za-z$-.]/g, "").trim())/100;
//  if(numbrs == amt) {
//      $(this).parents(".collection-products__col.collection-products__col--four").css("order",i);
//  }  
// });
    
// }
// $("ul.list--inline.pagination").css("order",finalarray.length);

//}
setTimeout(function(){
   $(document).on('change','#sort-by',function(e){ 
    e.preventDefault();
let page_url = window.location.pathname;
var get_url = window.location.href;
if(get_url.includes('?page')){
var get_split = get_url.split('?').pop();
var get_query = get_split.split('&')[0];
var sort_style = e.currentTarget.value;
$('#sort-by').attr('data',sort_style);
 var main_page_url = page_url+"?"+get_query+"&sort_by="+sort_style;
}else{
var sort_style = e.currentTarget.value;
$('#sort-by').attr('data',sort_style);
 var main_page_url = page_url+"?sort_by="+sort_style;
}
     window.location.href = main_page_url;
 //window.history.pushState({}, '', main_page_url);

var get_window = window.location.pathname;
 $.ajax({
  type: "GET",
   url: main_page_url,
  cache: false,
  success: function(data){ 
      $('ul.list--inline.pagination').html($(data).find('ul.list--inline.pagination').html());
   }
});

/*
$.ajax({
  type: "GET",
  url: main_page_url,
  cache: false,
  success: function(data){ 
     $('.collection-products__row').html($(data).find('.collection-products__row').html());
 
  }
});
  */
     
}); 
},1500);

/*
$(document).on('click','.product-card-v2__options--collection-page', function(e){
  e.preventDefault();
  var $this = $(this);
  var pp_handle = $(this).attr("data-pp");
  var data_pos = $(this).attr('data-position');
  $(this).parents(`.only_products_grid[data-pp="${pp_handle}"]`).find(`.product-card-v2__options--collection-page[data-position = "${data_pos}"]`).find('input').attr('checked', false);
  $(this).find('input').attr('checked', true);
  setTimeout(function(){
     var varComb = '';
     var opt1 = $this.parents(`.only_products_grid[data-pp="${pp_handle}"]`).find(`.product-card-v2__options--collection-page[data-position = "1"]`).find('input:checked').val();
      if(opt1 != ''){
          varComb = opt1;
      }
      if($this.parents(`.only_products_grid[data-pp="${pp_handle}"]`).find(`.product-card-v2__options--collection-page[data-position = "2"]`).length > 0){
         var opt2 = $this.parents(`.only_products_grid[data-pp="${pp_handle}"]`).find(`.product-card-v2__options--collection-page[data-position = "2"]`).find('input:checked').val();
         if(opt2 != ''){       
           varComb = `${opt1} / ${opt2}`;
         }
      }
   
       var variant = $this.parents(`.only_products_grid[data-pp="${pp_handle}"]`).find(`.jsproduct-select option[var-title="${varComb}"]`).val();
       console.log(variant);
       $.ajax({
        type: "GET",
        url: "/products/"+pp_handle+"?variant="+variant+"&view=product_data",
        cache: false,
        success: function(data){ 
         //   console.log(data);
            $('.only_products_grid-jtpl[data-pp="'+pp_handle+'"]').html(data);
        }
     });
   },500);
});

$(document).on('click','span.product-card-v2__button-text.js-available-button-text', function(e){
    e.preventDefault();
    var varId = $(this).parents('.only_products_grid').find('.product-card-v2__product-information-second-block').find('select[name="cstm-pp-jtpl"]').next().val();
    console.log(varId);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async : false,
      data: {
      quantity: 1,
      id: varId
      },
      dataType: 'json',
      success: function(response) {
        console.log("success")
          var A = window.Shopify.theme.sections.instances[3];
          console.log(A);
      //  var $this2 = window.Shopify.theme.sections.instances[3];
            // document.addEventListener("build:vue", function() {
            //     Array.from(document.querySelectorAll("#toggleMinicart")).forEach(function(Q) {
            //         return Q.addEventListener("click", A.toggleMinicart)
            //     })
            // });
            // A.container.querySelector(".js-blackout-minicart").addEventListener("click", A.toggleMinicart);
            // document.addEventListener("product:add", A.toggleMinicart);
            // A.initMinicart();
        
       // return false;
          setTimeout(function(){ 
           
        $.ajax({
          url: '/pages/mantra-privacy-policy/?view=miniajaxcart',
          method: 'GET',
          dataType: 'html',
          success: function(carttnew){
            console.log("data update");
            console.log(carttnew);
            var carDataNew = $(carttnew).find('#shopify-section-minicart').html();
            console.log('hii ' + carDataNew);
             $('#shopify-section-minicart').html(carDataNew);
            setTimeout(function(){ 
              $('.toggle-minicart').trigger('click');
             },500);
          },
          error: function(){
            console.log("data not update");
          }
        })
            },2000);

      },
      error: function(){
        console.log("fail")
      }
    });
});
*/

$(document).on('click','.js-collection-template-see',function(){
setTimeout(function(){
var data_val = $("select#sort-by option:selected").trigger("change");
},100);
});

  $(document).on('click','#sort-by',function(e){ 
    $("#sort-by option:first").hide();
    $(this).addClass("active-selectbox");
  });
  $(document).on("click", function(e) {
    if ($(e.target).is("#sort-by") === false) {
      $("#sort-by").removeClass("active-selectbox");
    }
  });
  
   var radioValue = $(".product-card__variant-swatches .input-container input:checked").next().attr('var_img');
  	$('.variant-image .product-single__image').attr('data-href',radioValue);
  
   $(document).on('click','.product-card__variant-swatches .input-container input',function(){
    
        var selectedValue = $(this).next().attr('var_img');
        $('.variant-image .product-single__image').attr('data-href',selectedValue);
  		$('.variant-image .product-single__image').trigger('zoom.destroy'); 
   });
  if ($(window).width() > 767) {

  $(document).on('click', '.withoutvar', function() {
    if($(this).find("img").hasClass("zoomImg")){
      $( this ).trigger('zoom.destroy'); 
    }else{
      var href = $(this).attr("data-href");
      if(href){
        $(this).zoom({url: href});
      }
    }


  });

  $(document).on('click', '.variant-image .product-single__image', function() {
    if($(this).find("img.imagezoom").hasClass("zoomImg")){
      console.log('in if');
      $( this ).trigger('zoom.destroy'); 
      $('.zoomImg').remove();
    }else{
      
      var href = $(this).attr("data-href");
      console.log('in else');
      if(href){
        
        $(this).zoom({url: href});
      }
    }

  });

  }

  $('.list_swatches1').each(function(){
     var possibles2   = []; 
    var option1 = $(this).find('input:checked').val();
    var option2 = $(this).next('.list_swatches2').find('input:checked').val();
   var combination2 = option1 +' / '+ option2;
   $(this).parents('.product-card-v2__variant-swatches').find(".jsproduct-select option").each(function(){
      var option_value = $(this).text().trim();
      if(option_value.includes(option1)){
        possibles2.push(option_value)
      }
   });
    var test = '';
    $(this).next('.list_swatches2').find('input').each(function(){
      var option2_flag=false;
      var option2_val = $(this).val();
      possibles2.forEach((variant) => {
        if (variant.includes(option2_val)) {
          option2_flag=true;
        }
        
      })
      if(option2_flag === false) {
        $(this).hide();
        $(this).next().hide();
      }else{
        
		
        $(this).show();
        $(this).next().show();
      
        
      }
		
    })
    
  });


  $(document).on('click','.list_swatches1 label',function(){
  var possibles2   = []; 
   var selectedVal = [];
   var option1 = $(this).prev().val();
   var option2 = $(this).parents('.list_swatches1').next('.list_swatches2').find('input:checked').val();
   var combination2 = option1 +' / '+ option2;
   $(this).parents('.product-card-v2__variant-swatches').find(".jsproduct-select option").each(function(){
      var option_value = $(this).text().trim();
      if(option_value.includes(option1)){
        possibles2.push(option_value)
      }
   });
    var test = '';
    $(this).parents('.list_swatches1').next('.list_swatches2').find('input').each(function(){
      var option2_flag=false;
      var option2_val = $(this).val();
      possibles2.forEach((variant) => {
        if (variant.includes(option2_val)) {
          option2_flag=true;
        }
        
      })
      if(option2_flag === false) {
        $(this).hide();
        $(this).next().removeClass('avail').hide();
      }else{
        
		
        $(this).show();
        $(this).next().addClass('avail').show();
        var firstVal = $(this).val();
        selectedVal.push(firstVal);
		var firstValue = selectedVal[0];
        var attr = $(this).attr('value');
        if (attr == firstValue) {
           $(this).click();
            }
        
      }
		
    })
    
  });
  if ($("header").hasClass("make_background_white")) {
    $("body").addClass("header_has_bg");
  }
});

function slider_init_cart_drawer(){
var get_speed = $(".trans_speed").val();
    mySwiper =  new Swiper('.main_slider_div', {
        loop: true,
        slidesPerView: 1,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
autoplay: {
    delay: get_speed,
  },
        paginationClickable: true,
        spaceBetween: 20,
   
    });
}
function cart_messages(){

var get_gift = $(".gift_price_minicart").val();
var get_percentage = $(".percentage_off").val();
var get_free_shipping_text = $(".free_shipping_text").val();
var two_items_text = $(".two_items_text").val();
var get_gift_before_text = $(".gift_text1").val();
var text_after = $(".text_after").val();
var one_more_text = $(".one_more_text").val();
  jQuery.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'json',
    success: function(cartnew){ 
      var get_price2 = cartnew.total_price;
      var get_price = get_price2 * 1;
if (typeof get_price === "undefined") {
    // ...
    }else{
        if(get_price > 0){
        var get_length = $(".free_shipping_wrapper").length;
          if(get_length == 0 ){
     $(".cart-header").append('<div class="gift-product__message free_shipping_wrapper swiper-slide">'+get_free_shipping_text+'</div>');

          }
    }else{
      $(".free_shipping_wrapper").remove();
     }
     if(get_price <= get_gift){
var get_length2 = $(".free_gift_wrapper").length;
          if(get_length2 == 0 ){
     $(".cart-header").append('<div class="gift-product__message text_before_gift free_gift_wrapper swiper-slide">'+get_gift_before_text+'</div>');

          }else if(get_length2 > 0){
   $(".free_gift_wrapper").removeClass('text_after_wrapper');
          $(".free_gift_wrapper").addClass('text_before_gift');
            $(".free_gift_wrapper").text(get_gift_before_text);

            }
    }else{
        var get_length4 = $(".free_gift_wrapper").length;
          if(get_length4 == 0 ){
     $(".cart-header").append('<div class="gift-product__message text_after_wrapper free_gift_wrapper swiper-slide">'+text_after+'</div>');

          }else if(get_length4 >  0 ){
          $(".free_gift_wrapper").removeClass('text_before_gift');
          $(".free_gift_wrapper").addClass('text_after_wrapper');

          $(".free_gift_wrapper").text(text_after);
       }
          }
        var check_exist2 = $(".main_slider_div").length;
          if(check_exist2 == 0 ){
          $('.free_shipping_wrapper,.free_gift_wrapper').wrapAll('<div class="main_slider_div swiper-container"><div class="swiper-wrapper"></div></div>');  
           // $(".main_slider_div").append('<div class="swiper-button-prev"></div> <div class="swiper-button-next"></div>')

            }

    if(get_price > get_gift && get_price <= get_percentage ){
var get_length3 = $(".get_offer").length;
          if(get_length3 == 0 ){
         // $('<div class="get_offer">Get 15% off on your order of $150+</div>').append(".main_slider_div");
          $(".main_slider_div .swiper-wrapper").append('<div class="gift-product__message before_percent_text get_offer swiper-slide">'+two_items_text+'</div>');
          }else if(get_length3 > 0 ){
      $(".get_offer").removeClass('text_after_percent');
              $(".get_offer").addClass('before_percent_text');
              $(".get_offer").text(two_items_text);
    }
      }else if(get_price > get_percentage){
     var get_length5 = $(".get_offer").length;
          if(get_length5 == 0 ){
         // $('<div class="get_offer">Congrats !! you have unlocked 15% off</div>').append(".cart-body");
          $(".main_slider_div .swiper-wrapper").append('<div class="gift-product__message text_after_percent get_offer swiper-slide">'+one_more_text+'</div>');

          }else if(get_length5 > 0  ){
              $(".get_offer").removeClass('before_percent_text');
              $(".get_offer").addClass('text_after_percent');

      $(".get_offer").text(one_more_text);
         }


      }else{
      $(".get_offer").remove();
    }
      if($(".main_slider_div").hasClass('swiper-container-initialized')){

   mySwiper.destroy( true, true );
      slider_init_cart_drawer();
      }else{
      slider_init_cart_drawer();

       }
  

    }

    }
  });
 

}
// $('.ddl_sort-by').click(function(){
//     if($(this).hasClass('active')){
//        $(".ddl-options.ddl-options-sort-by").show();
//     } else {
//        $(".ddl-options.ddl-options-sort-by").hide(); 
//     }
// });
$("#sort-by").change(function(e){ 
e.preventDefault();
let page_url = window.location.pathname;
var get_url = window.location.href;
var sort_style = e.currentTarget.value;
if(sort_style == 'best-selling' || sort_style == 'created-descending') {
if(get_url.includes('?page')){
var get_split = get_url.split('?').pop();
var get_query = get_split.split('&')[0];
var sort_style = e.currentTarget.value;
$('#sort-by').attr('data',sort_style);
 var main_page_url = page_url+"?"+get_query+"&sort_by="+sort_style;
}else{
var sort_style = e.currentTarget.value;
console.log(sort_style);
$('#sort-by').attr('data',sort_style);
 var main_page_url = page_url+"?sort_by="+sort_style;
}
 window.history.pushState({}, '', main_page_url);

var get_window = window.location.pathname;
 $.ajax({
  type: "GET",
  url: main_page_url,
  cache: false,
  success: function(data){ 
    $('.collection-products__row').html($(data).find(".collection-products__row").html());
   
}
});
}
});